module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-fluid",
    attrs: {
      "id": "demo"
    }
  }, [_c('div', {
    staticClass: "col-md-4 col-md-offset-4 m-t-20"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("数字范围：")]), _vm._v(" "), _c('div', {
    staticClass: "input-group m-b-5"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("min")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.setting.min),
      expression: "setting.min",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.setting.min)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.setting.min = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("max")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.setting.max),
      expression: "setting.max",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.setting.max)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.setting.max = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("数字分割：")]), _vm._v(" "), _c('div', {
    staticClass: "input-group m-b-5"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("sep")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.setting.sep),
      expression: "setting.sep",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.setting.sep)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.setting.sep = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("step")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.setting.step),
      expression: "setting.step"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.setting.step)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.setting.step = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('pre', [_vm._v(_vm._s(JSON.stringify(_vm.setting, null, 4)))])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("演示：")]), _vm._v(" "), _c('number-input', {
    staticClass: "form-control",
    attrs: {
      "min": _vm.setting.min,
      "max": _vm.setting.max,
      "sep": _vm.setting.sep,
      "step": _vm.setting.step
    },
    model: {
      value: (_vm.setting.val),
      callback: function($$v) {
        _vm.setting.val = $$v
      },
      expression: "setting.val"
    }
  })], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-d2722492"}!./~/.11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/js/app/number-input-demo/component/demo.vue
// module id = 8
// module chunks = 0